<template>
	<div class="parent" style="height:calc(100vh - 50px);" v-hotkey="keymap">
		<dialogue
		:title="'Empty Box'"
		:paragraph="'Are you sure you want to empty box '+term+'?'"
		:button_names="['Empty']"
		:show="delete_dialogue"
		v-on:dialogue="emptyBoxes"
		v-on:cancel="cancelDelete"
		></dialogue>

        <input id="scanText" v-on:change="scan" class="textfield" v-model="scanText" tabindex=0></input>

		<layout-2
		:id=pageid2
		:navbar=true
		:title="'Edit Inventory Item'"
		:use_radio=false
		:term=term
		style="width:100%;"
		:key=updateKey
		v-on:save="checkItem"
		:reroute=false></layout-2>

		<layout-1
			:table_name="'Items'"
			:filter_options=null
			:id=pageid1
			:searchbar=false
			:navbar=false
			:button_perm="'88'"
			:button_name="'Select'"
			:term=term
			:reroute="'/0322'"
			:select_reroute=true
			:usePages=false
			:key="updateKey"
			style="width:100%; height:calc(100vh - 350px);"
		></layout-1>
		<div class="nav-bar">
			<div>
				<button v-for="(item, index) in nav_items" v-if="perms.includes(nav_item_perms[index])" v-on:click="button(item)">{{item}}</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			perms:[],
			pageid1:PAGES.EDIT_INVENTORY_BOX_PAGE,
			pageid2:PAGES.EDIT_INVENTORY_BOX_DETAIL_PAGE,

			pageid3:PAGES.SCAN_INVENTORY_PAGE_BOX,
			pageid4:PAGES.SCAN_INVENTORY_BOX_PAGE_ALT,
			pageid5:PAGES.EMPTY_INVENTORY_BOX_PAGE,
			nav_items:['Inventory List', 'Edit Inventory List', 'Scan Item', 'Empty Box'],
			nav_item_perms:['88','88','89', '89'],
			scanText:'',
			updateKey:0,
			delete_dialogue:false,
		}
	},
	computed: {
		keymap() {
			return {
				"ctrl+e": this.openScanner,
			};
		}
	},
	async created () {
		this.perms = api.getPerms();
	},
	mounted () {
		//this.openScanner()
	},
	methods:{
		openScanner(){
			document.getElementById("scanText").focus();
			this.scanText = ""
		},
		scan(){
			const itemVal = 'LDPAV2-'
			const boxVal = 'LDPAV2BOX-'

			var id = 0

            if(this.scanText.substr(0,itemVal.length)==itemVal){
				this.scanText = this.scanText.substr(itemVal.length)
				api.postData(
					{
						type:"insert",
						data:{
							pageid:this.pageid1,
							term:this.term,
							item:this.scanText,
						}
					}
				).then((res) => {
					this.updateKey++;
					this.scanText = ""
				});
			}else if(this.scanText.substr(0,boxVal.length)==boxVal){
				this.scanText = this.scanText.substr(boxVal.length)
				api.postData(
					{
						type:"insert",
						data:{
							pageid:this.pageid3,
							term:this.scanText,
						}
					}
				).then((res) => {
					router.push('/0511?q='+this.scanText);
					this.updateKey++;
					this.scanText = ""
				});
			}else{
				api.postData(
					{
						type:"insert",
						data:{
							pageid:this.pageid4,
							term:this.term,
							item:this.scanText,
						}
					}
				).then((res) => {
					this.updateKey++;
					this.scanText = ""
				});
			}
		},
		async button (name){
			if(name=="Empty Box"){
				this.delete_dialogue = true;
			}else{
				api.postData(
					{
						type:"button",
						data:{
							pageid:this.pageid1,
							buttonname:name,
						}
					}
				).then((res) => {
					if(res.data.data.to!=null) {
						if(res.data.data.useterm) {
							router.push('/'+res.data.data.to+'?q='+this.term);
						} else {
							router.push('/'+res.data.data.to);
						}
					}
				});
			}
		},
		async emptyBoxes(){
			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid5,
						term:this.term,
					}
				}
			).then((res) => {
				this.updateKey++;
				this.scanText = ""
			});
		},
		async cancelDelete(){
			this.delete_dialogue = false;
		}
	},
}
</script>

<style scoped>
.textfield{
    width:90%;
	margin-left:5%;
	margin-right:5%;
	margin-top:0px;
	font-size:0px;
	height:0px;
	opacity: 0;
}
.textfield:focus{
	margin-top:16px;
	height:auto;
	font-size:24px;
	opacity: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/edit/Edit_Inventory_Boxes.vue